import * as actionTypes from './actionTypes';
import { getItemsBetweenIndex } from '../../../../utils/helper';

// Init state
export const servicesDeletedState = {
  isLoading: true,
  isLoadingTable: false,
  updateList: false,
  isInitPage: false,
  initPageError: null,

  search: '',
  searchOption: null,
  modal: null,
  filters: {
    providers: null,
    query: null,
    search_type: null,
    sort_column: null,
    sort_direct: null,
    type: null,
  },
  pagination: null,
  services: [],
  sort: {},
  providers: [],
  types: [],
  configuration: null,
  checked: [],
  lastCheckedIndex: null,
};

export const servicesDeletedReducer = (state, action) => {
  const { payload } = action;
  switch (action.type) {
  case actionTypes.SERVICES_DELETED_LOADING_TABLE:
    return {
      ...state,
      isLoadingTable: true,
    }
  case actionTypes.SERVICES_DELETED_LIST_UPDATE:
    return {
      ...state,
      isLoadingTable: true,
      updateList: true,
    }
  case actionTypes.SERVICES_DELETED_LIST_UPDATE_SUCCESS:
    return {
      ...state,
      isLoadingTable: false,
      updateList: false,
      pagination: payload.pagination,
      services: payload.services,
      search_type: payload.search_type,
      sort: payload.sort,
    }
  case actionTypes.SERVICES_DELETED_LIST_UPDATE_ERROR:
    return {
      ...state,
      isLoadingTable: false,
      isInitPage: true,
      initPageError: {
        data: payload.data,
        status: payload.status,
        statusText: payload.statusText,
      },
    }
  case actionTypes.SERVICES_DELETED_LIST_SUCCESS:
    return {
      ...state,
      isInitPage: true,
      initPageError: null,
      isLoadingTable: false,
      pagination: payload.pagination,
      configuration: payload.configuration,
      providers: payload.providers,
      types: payload.types,
      services: payload.services,
      filters: payload.filters,
      search_type: payload.search_type,
      sort: payload.sort,
    }
  case actionTypes.SERVICES_DELETED_CHECKED_ADD:
    return {
      ...state,
      lastCheckedIndex: payload.index,
      checked: [...state.checked, payload.id],
    }
  case actionTypes.SERVICES_DELETED_CHECKED_ADD_SHIFT:
    const addedItems = getItemsBetweenIndex(state.services, state.lastCheckedIndex, payload.index)
    return {
      ...state,
      lastCheckedIndex: payload.index,
      checked: state.checked.concat(addedItems),
    }
  case actionTypes.SERVICES_DELETED_CHECKED_ADD_ID:
    return {
      ...state,
      checked: payload.checked,
    }
  case actionTypes.SERVICES_DELETED_CHECKED_DELETE:
    return {
      ...state,
      lastCheckedIndex: payload.index,
      checked: state.checked.filter((id) => id !== payload.id),
    }
  case actionTypes.SERVICES_DELETED_CHECKED_DELETE_SHIFT:
    const deletedItems = getItemsBetweenIndex(state.services, state.lastCheckedIndex, payload.index)
    return {
      ...state,
      lastCheckedIndex: payload.index,
      checked: state.checked.filter((id) => !deletedItems.includes(id)),
    }
  case actionTypes.SERVICES_DELETED_CHECKED_MASS_DELETE:
    return {
      ...state,
      checked: [],
    }
  case actionTypes.SERVICES_DELETED_CHECKED_MASS_ADD:
    return {
      ...state,
      checked: state.services.map((service) => service.id),
    }
  case actionTypes.SERVICES_DELETED_CHANGE_FILTER:
    return {
      ...state,
      isLoadingTable: true,
    }
  case actionTypes.SERVICES_DELETED_CHANGE_FILTER_TYPE:
    return {
      ...state,
      isLoadingTable: true,
      filters: {
        ...state.filters,
        type: payload.type,
      },
      checked: [],
    }
  case actionTypes.SERVICES_DELETED_CHANGE_FILTER_PROVIDERS:
    return {
      ...state,
      isLoadingTable: true,
      filters: {
        ...state.filters,
        providers: payload.providers,
      },
      checked: [],
    }
  case actionTypes.SERVICES_DELETED_CHANGE_FILTER_QUERY:
    return {
      ...state,
      isLoadingTable: true,
      filters: {
        ...state.filters,
        query: payload.query,
      },
      checked: [],
    }
  case actionTypes.SERVICES_DELETED_CHANGE_FILTER_SEARCH_TYPE:
    return {
      ...state,
      isLoadingTable: !!state.filters.query,
      filters: {
        ...state.filters,
        search_type: payload.searchType,
      },
      checked: state.filters.query ? [] : state.checked,
    }
  case actionTypes.SERVICES_DELETED_MODAL_CLOSE:
    return {
      ...state,
      modal: null,
    }
  case actionTypes.SERVICES_DELETED_MODAL_OPEN:
    return {
      ...state,
      modal: {
        name: payload.name,
        data: payload.data,
      },
    }
  case actionTypes.SERVICES_DELETED_CHANGE_PAGE:
    return {
      ...state,
      isLoadingTable: true,
      pagination: {
        ...state.pagination,
        current_page: Number(payload.page),
      },
      checked: [],
    }
  case actionTypes.SERVICES_DELETED_RESTORE:
    return {
      ...state,
      isLoadingTable: true,
    }
  case actionTypes.SERVICES_DELETED_RESTORE_SUCCESS:
    return {
      ...state,
      isLoadingTable: true,
      updateList: true,
      modal: null,
    }
  case actionTypes.SERVICES_DELETED_RESTORE_ERROR:
    return {
      ...state,
      isLoadingTable: false,
    }
  case actionTypes.SERVICES_DELETED_RESTORE_ALL:
    return {
      ...state,
      isLoadingTable: true,
      updateList: true,
      modal: null,
      checked: [],
    }
  case actionTypes.SERVICES_DELETED_CHANGE_SORT:
    return {
      ...state,
      isLoadingTable: true,
      filters: {
        ...state.filters,
        sort: payload.sort,
      },
      checked: [],
    }
  default:
    throw new Error();
  }
};

// Action creator
export function listSuccess(payload) {
  return { type: actionTypes.SERVICES_DELETED_LIST_SUCCESS, payload }
}

export function loadingTable() {
  return { type: actionTypes.SERVICES_DELETED_LOADING_TABLE }
}

export function updateListSuccess(payload) {
  return { type: actionTypes.SERVICES_DELETED_LIST_UPDATE_SUCCESS, payload }
}

export function updateListError(data, status, statusText) {
  return { type: actionTypes.SERVICES_DELETED_LIST_UPDATE_ERROR,
    payload: {
      data,
      status,
      statusText,
    } };
}
export function changeFilterProvider(providers) {
  return { type: actionTypes.SERVICES_DELETED_CHANGE_FILTER_PROVIDERS, payload: { providers } };
}

export function changeFilterType(type) {
  return { type: actionTypes.SERVICES_DELETED_CHANGE_FILTER_TYPE, payload: { type } };
}

export function changeQuery(query) {
  return { type: actionTypes.SERVICES_DELETED_CHANGE_FILTER_QUERY, payload: { query } };
}

export function changeSearchType(searchType) {
  return { type: actionTypes.SERVICES_DELETED_CHANGE_FILTER_SEARCH_TYPE, payload: { searchType } };
}

export function restore() {
  return { type: actionTypes.SERVICES_DELETED_RESTORE };
}

export function restoreSuccess() {
  return { type: actionTypes.SERVICES_DELETED_RESTORE_SUCCESS };
}

export function restoreError() {
  return { type: actionTypes.SERVICES_DELETED_RESTORE_ERROR };
}

export function restoreAll() {
  return { type: actionTypes.SERVICES_DELETED_RESTORE_ALL };
}

export function tableSort(sort) {
  return { type: actionTypes.SERVICES_DELETED_CHANGE_SORT, payload: { sort } };
}

export function checkedMassAdd() {
  return { type: actionTypes.SERVICES_DELETED_CHECKED_MASS_ADD };
}

export function checkedMassDelete() {
  return { type: actionTypes.SERVICES_DELETED_CHECKED_MASS_DELETE };
}

export function checkedAdd(id, index) {
  return { type: actionTypes.SERVICES_DELETED_CHECKED_ADD, payload: { id, index } };
}

export function checkedAddShift(id, index) {
  return { type: actionTypes.SERVICES_DELETED_CHECKED_ADD_SHIFT, payload: { id, index } };
}

export function checkedAddIds(checked) {
  return { type: actionTypes.SERVICES_DELETED_CHECKED_ADD_ID, payload: { checked } };
}

export function checkedDelete(id, index) {
  return { type: actionTypes.SERVICES_DELETED_CHECKED_DELETE, payload: { id, index } };
}

export function checkedDeleteShift(id, index) {
  return { type: actionTypes.SERVICES_DELETED_CHECKED_DELETE_SHIFT, payload: { id, index } };
}

export function changePage(page) {
  return { type: actionTypes.SERVICES_DELETED_CHANGE_PAGE, payload: { page } };
}

export function modalClose() {
  return { type: actionTypes.SERVICES_DELETED_MODAL_CLOSE };
}

export function modalOpen(name, data) {
  return { type: actionTypes.SERVICES_DELETED_MODAL_OPEN, payload: { name, data } };
}
